import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import React from "react";
import {Item} from "../CharStyled";
import {useSignals} from "@preact/signals-react/runtime";
import {s_char} from "../../_signals/s_char";
import {displaySchwellehModNSC} from "../../_helper/displaySchwelleModNSC";
import updChar from "../../_sig_api/updChar";

export function CharWUNDNSC() {
    useSignals()
    return <Grid item sm={2} xs={4}>
        <Item>
            <TextField InputLabelProps={{shrink: true}}
                       onChange={e => updChar([{k: 'wund', v: parseInt(e.target.value)}])}
                       style={{marginLeft: 8, maxWidth: 80}}
                       value={s_char.value.wund}
                       variant="standard" type="number" label="Wundschw" id="wund"
                       name="wund"/>
            {displaySchwellehModNSC('wund')}
        </Item>
    </Grid>;
}